export const INITIAL_INTERVAL = 1000;
export const INTERVAL_MULTIPLIER = 1.5;
export const SHOW_CONTENT_AFTER_N_RETRIES = 3;
export const MAX_RETRIES = 7;

const trackerSuccess = {
  initialize() {
    if (this.isTrackerStale() && !this.isTrackerFinalized()) {
      this.reloadPage();
    } else {
      this.showContent();
    }
  },

  isTrackerStale() {
    return !!$('#is_tracker_stale').val();
  },

  isTrackerFinalized() {
    return !!$('#is_tracker_finalized').val();
  },

  showContent() {
    $('.loading').show();
    $('.spinner').hide();
  },

  reloadPage(interval = INITIAL_INTERVAL, attempt = 1) {
    $('#content-block').load(
      `${window.location.href}?refresh=true #tracker-success-content`,
      (responseText, textStatus, xhr) => {
        const { status } = xhr;
        if (this.isTrackerFinalized() || attempt >= MAX_RETRIES) {
          this.showContent();
          // 404's occur on /refresh when tracker.create is backed up
        } else if (status !== 404 && (status >= 400 || this.isTrackerStale())) {
          if (attempt >= SHOW_CONTENT_AFTER_N_RETRIES) {
            this.showContent();
          }
          window.setTimeout(() => {
            this.reloadPage(interval * INTERVAL_MULTIPLIER, attempt + 1);
          }, interval);
        } else {
          this.showContent();
        }
      },
    );
  },
};

export default function () {
  trackerSuccess.initialize();
}
